export default __webpack_public_path__ + "static/media/ballshuffling.49392e85.mp3";